import React from 'react';

import { EntityContainer } from '../../containers/EntityContainer/EntityContainer';
import {
  EntityMetadataContainer } from '../../containers/EntityMetadataContainer/EntityMetadataContainer';
import LandingPageContainer from '../../containers/LandingPageContainer/LandingPageContainer';
import { LayoutContainer } from '../../containers/LayoutContainer/LayoutContainer';
import { resolvePathLandingPage } from '../../queries/resolvePaths/resolvePathLandingPage.gql';

const LandingPage = React.memo(() => {
  return (
    <>
      <EntityContainer resolvePath={resolvePathLandingPage} />
      <EntityMetadataContainer />
      <LayoutContainer headerProps={{ disableSearch: true }}>
        <LandingPageContainer />
      </LayoutContainer>
    </>
  );
});

LandingPage.displayName = 'LandingPage';
export default LandingPage;
